import type { GetCurrentUserResponse } from '@/api/user/getCurrentUser.ts';
import type { FxCashProductName } from '@/store/cash/state.ts';
import type { FxFlexiForwardProductName } from '@/store/flexi-forward/state.ts';
import type { FxForwardAccumulatorProductName } from '@/store/forwardAccumulator/state.ts';
import type { FxOptionProductName } from '@/store/option/state.ts';
import type { OrderType } from '@/store/orders/state.ts';
import type { FxSwapProductName } from '@/store/swap/state.ts';
import type { FxTargetAccumulatorProductName } from '@/store/targetAccumulator/state.ts';

export function hasAccessToTileProduct(
  productName:
    | FxCashProductName
    | FxSwapProductName
    | FxOptionProductName
    | FxFlexiForwardProductName
    | OrderType
    | FxTargetAccumulatorProductName
    | FxForwardAccumulatorProductName
    | undefined,
  productsAccess: GetCurrentUserResponse['productsAccess'],
): boolean {
  switch (productName) {
    case 'FxFlexiForward':
      return productsAccess.americanForward;
    case 'FxFwd':
      return productsAccess.forward;
    case 'FxNdf':
      return productsAccess.forward && productsAccess.nonDeliverable;
    case 'Vanilla':
    case 'Trigger':
    case 'Binary':
    case 'RiskReversal':
    case 'Straddle':
    case 'Strangle':
      return productsAccess.option;
    case 'FxSpot':
      return productsAccess.spot;
    case 'FxSwap':
      return productsAccess.swap;
    case 'TakeProfitOrder':
      return productsAccess.takeProfit;
    case 'Twap+Order':
      return productsAccess.twap;
    case 'StopLossOrder':
      return productsAccess.stopLoss;
    case 'FalconOrder':
      return productsAccess.falcon;
    case 'NightjarOrder':
      return productsAccess.nightjar;
    case 'FixingOrder':
      return productsAccess.fixing;
    case 'CallOrder':
      return productsAccess.callOrder;
    case 'FxTargetAccumulator':
      return productsAccess.targetAccu;
    case 'FxForwardAccumulator':
      return productsAccess.forwardAccu;
    case undefined:
      return false;
  }
}
